var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row pt-1" },
    [
      _vm.messages
        ? _c("small", {
            staticClass: "mb-0 pb-0",
            domProps: { innerHTML: _vm._s(_vm.messages) },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ob1-legal-notice",
        {
          staticClass: "py-1",
          attrs: {
            "button-id": _vm.title + "Id",
            "button-label": _vm.title,
            "collapsed-block-id": _vm.title + "CollapsedId",
          },
        },
        [
          _c(
            "ul",
            { staticClass: "list-unstyled" },
            _vm._l(_vm.mentions, function (mention, index) {
              return _c(
                "li",
                { key: "mention-" + index, staticClass: "mb-1" },
                [_c("small", { domProps: { innerHTML: _vm._s(mention) } })]
              )
            }),
            0
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }